import { VALIDATEINVITES_SUCCESS, VALIDATEINVITES_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const validateInviteReducer = (state = initialState, action) => {
    switch (action.type) {
        case VALIDATEINVITES_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case VALIDATEINVITES_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default validateInviteReducer;
